import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { EasmArtifactsInventoryGridController } from '../controller/EasmArtifactsInventoryGridController';

export class EasmArtifactsInventoryGridWebComponent extends BaseWebComponentElement {
  public controller!: EasmArtifactsInventoryGridController;

  public constructor() {
    super();

    this.initialSetup({
      controllerConstructor: EasmArtifactsInventoryGridController,
    });
  }

  getCompanyIdFilterValue(): string {
    return this.controller.getCompanyIdFilterValue();
  }
}
